import { render } from "./ResumeModalSendToArchive.vue?vue&type=template&id=5481b28d"
import script from "./ResumeModalSendToArchive.vue?vue&type=script&lang=js"
export * from "./ResumeModalSendToArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__